/**
 * Collection tabs: event delegation so clicks work with deferred scripts and theme editor.
 */
(function () {
  if (window.__collectionTabsBound) return;
  window.__collectionTabsBound = true;

  /**
   * @param {HTMLElement} root
   * @param {HTMLButtonElement} activeTab
   */
  function activateTab(root, activeTab) {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    const index = tabs.indexOf(activeTab);
    if (index === -1) return;

    const panels = tabs.map((tab) =>
      document.getElementById(tab.getAttribute('aria-controls') || '')
    );
    const shopAll = root.querySelector('[data-collection-tabs-shop-all]');

    tabs.forEach((tab, i) => {
      const selected = i === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
      const panel = panels[i];
      if (panel) {
        panel.classList.toggle('collection-tabs__panel--active', selected);
        panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
        panel.removeAttribute('hidden');
      }
      if (selected && shopAll) {
        const url = tab.dataset.collectionUrl;
        if (url) shopAll.setAttribute('href', url);
        const suffixEl = shopAll.querySelector('[data-collection-tabs-shop-suffix]');
        const suffix = (tab.textContent || '').trim();
        if (suffixEl) suffixEl.textContent = suffix;
        const prefix = (shopAll.getAttribute('data-shop-all-prefix') || '').trim();
        const label = [prefix, suffix].filter(Boolean).join(' ');
        shopAll.setAttribute('aria-label', label);
      }
    });
  }

  document.addEventListener(
    'click',
    function (e) {
      const tab = e.target.closest('[data-collection-tabs] [role="tab"]');
      if (!tab) return;
      const root = tab.closest('[data-collection-tabs]');
      if (!root || !root.contains(tab)) return;
      activateTab(root, tab);
    },
    false
  );

  document.addEventListener(
    'keydown',
    function (e) {
      if (e.target == null || !(e.target instanceof Element)) return;
      const tab = e.target.closest('[data-collection-tabs] [role="tab"]');
      if (!tab || e.target !== tab) return;
      const root = tab.closest('[data-collection-tabs]');
      if (!root) return;

      const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
      const index = tabs.indexOf(tab);
      if (index === -1) return;

      let next = index;
      if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
        e.preventDefault();
        next = (index + 1) % tabs.length;
      } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
        e.preventDefault();
        next = (index - 1 + tabs.length) % tabs.length;
      } else if (e.key === 'Home') {
        e.preventDefault();
        next = 0;
      } else if (e.key === 'End') {
        e.preventDefault();
        next = tabs.length - 1;
      } else {
        return;
      }
      tabs[next].focus();
      activateTab(root, tabs[next]);
    },
    false
  );
})();
